export const INITIAL_SHIPMENT = {
    tracking_id: "",
    tracking_link: "",
    e_way_bill_no: "",
    dispatch_date: "",
    delivery_date: "",
    invoice: "",
    e_way_bill: ""
}